import { h } from 'preact'
import { renderMessageBody } from '../chat-markdown-editor.js'

/**
 * BubbleContent — renders the text body of a message.
 *
 * Props: { message, isImageOnly }
 *
 * Prefer server-rendered body_html when present; otherwise render markdown
 * client-side (GFM + autolink + @mentions) via renderMessageBody.
 */
export function BubbleContent({ message, isImageOnly }) {
  if (isImageOnly) return null

  const body = message.body || message.body_html || ''
  if (!body.trim()) return null

  const html = message.body_html
    ? message.body_html
    : renderMessageBody(body)

  return (
    <div
      class="chat-message-body"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}

/**
 * isImageOnlyMessage — true when the message has attachments but no text body.
 * Every attachment kind (image, video, document, generic file) renders
 * bubble-less (standalone), matching the mobile app across desktop (dock +
 * full screen) and iOS/Android. Only a text body forces the bubble.
 */
export function isImageOnlyMessage(message) {
  const atts = message.attachments ?? []
  if (atts.length === 0) return false
  const body = message.body || message.body_html || ''
  return !body.trim()
}
